<template lang="pug">
#permission
  el-form(ref="permForm" :model="permForm" size="small"  label-width="100px" label-position="right")
    el-form-item(label="发起权限")
      el-button.addPeople(icon="el-icon-plus" type="text" @click="openChooseMember") 选择人员、角色或标签
      .tips 提示：如果不设置发起权限，则所有人都有权限发起此流程
      userAll(ref="userAll" :userList="permissionList" v-if="permissionList.length>0" @deleteUser="deleteAllUser")
    el-form-item(label="驳回规则" prop="rejectRuleCode")
      el-radio(v-model="permForm.rejectRuleCode" :label="0" :disabled="isViewMode" @change="updateperm") 驳回到发起人后，重新走全部审批流程
      el-radio(v-model="permForm.rejectRuleCode" :label="1" :disabled="isViewMode" @change="updateperm") 驳回到发起人后，跳过之前已审批阶段
    el-form-item(label="异常处理" prop="rejectRuleCode")
      el-radio(v-model="permForm.noApproveUserStrategy" :label="1" :disabled="isViewMode" @change="errorChange") 自动同意
      el-radio(v-model="permForm.noApproveUserStrategy" :label="2" :disabled="isViewMode" @change="errorChange") 转交指定人处理（指定成员异常将自动通过）
      .tips 提示：审批节点内成员离职、为空等情况的处理方式
    el-form-item(label="转交人" v-if="permForm.noApproveUserStrategy === 2")
      i.el-icon-circle-plus.addStyleApprove(:class="{'noClick':isViewMode}" title="选择人员" @click="openPerson" v-if="userList.length===0")
      userItem(:userList="userList" :disabled="isViewMode" v-if="userList.length>0"  @deleteUser="deleteUser")
    el-form-item(label="自动审批" prop="autoApprovalStrategy")
      el-radio.block(v-model="permForm.autoApprovalStrategy" :label="3" :disabled="isViewMode" @change="updateperm") 每个节点都需要审批
      el-radio.block(v-model="permForm.autoApprovalStrategy" :label="1" :disabled="isViewMode" @change="updateperm") 仅首个节点需审批，其余自动同意
      el-radio.block(v-model="permForm.autoApprovalStrategy" :label="2" :disabled="isViewMode" @change="updateperm") 仅连续审批时自动同意
      el-radio.block(v-model="permForm.autoApprovalStrategy" :label="4" :disabled="isViewMode" @change="updateperm") 审批人和发起人是同一人，审批自动通过
      .tips 提示：同一个审批人重复审批同一个流程时
    el-form-item(label="提交权限" prop="allowDelegatorSubmit")
      el-checkbox(v-model="permForm.allowDelegatorSubmit" :true-label="1" :false-label="0" :disabled="isViewMode" @change="updateperm") 允许代他人提交申请
</template>

<script>
import EditMode from "@/CommonDP/enums/EditMode";
import { flowParams, updateParams } from "@/CommonDP/components/processComponents/config";
import choosePeople from "@/CommonDP/components/processComponents/config/choosePeople.vue";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
import userItem from "@/CommonDP/components/chooseMember/userItem.vue";
import userAll from "@/CommonDP/components/chooseMember/userAll.vue";
import permission from "@/CommonDP/components/processComponents/editorCom/permission.vue";


export default {
  components: { choosePeople, userItem, userAll },
  props: {
    viewMode: {
      type: Number,
      default: EditMode.CREATE_0
    }
  },
  data () {
    return {
      EditMode: EditMode,
      permForm: flowParams.permForm
      // userList: flowParams.permForm.userList || [] // 转交人
    };
  },
  computed: {
    isViewMode() {
      return this.viewMode === EditMode.VIEW_2;
    },
    userList() {
      return flowParams.permForm.userList || [];
    },
    permissionList() {
      return flowParams.permForm.permissionList || [];
    }
  },
  methods: {
    async openChooseMember() {
      const props = {
        max: Infinity,
        codePri: ["User", "SpecRole", "PrjRole", "Label"],
        usersList: this.permForm.permissionList
      };
      const val = await openMember(props);
      this.permForm.permissionList = val?.map(e => {
        return {
          ...e,
          userType: this.getUserType(e.selectCode),
          userName: e.name
        };
      });
      this.updateperm();
    },
    deleteAllUser(val) {
      this.permForm.permissionList = this.permForm.permissionList.filter(e => !(e.userType === val.userType && e.userId === val.userId));
      this.updateperm();
    },
    getUserType(selectCode) {
      switch (selectCode) {
        case "User":
          return "user";
        case "SystemRole":
          return "sysRole";
        case "SpecRole":
          return "specRole";
        case "PrjRole":
          return "prjRole";
        case "Label":
          return "tag";
        default:
          return "";
      }
    },
    async openPerson() {
      if (this.isViewMode) { return; }
      const props = {
        max: 1,
        codePri: ["User"],
        userIds: this.permForm.defaultApproveUserId
      };
      const val = await openMember(props);
      this.permForm.defaultApproveUserId = val[0].userId;
      this.permForm.defaultApproveUserName = val[0].name;
      this.permForm.userList = val;
      this.updateperm();
    },
    deleteUser() {
      this.permForm.userList = [];
      this.permForm.defaultApproveUserId = "";
      this.permForm.defaultApproveUserName = "";
      this.updateperm();
    },
    errorChange() {
      if (this.permForm.noApproveUserStrategy === 1) {
        this.permForm.defaultApproveUserId = "";
        this.permForm.defaultApproveUserName = "";
      }
      this.updateperm();
    },
    updateperm() {
      // console.log("permForm:", this.permForm);
      updateParams("permForm", this.permForm);
    }
  }
};
</script>

<style lang="scss" scoped>
#permission{
  max-width: 800px;
  margin: 0 auto;
}
.block{
  display: block;
}
.tips {
  margin-left: 20px;
  color: #888;
  font-size: 0.8em;
}
.addPeople{
  margin-left: 5px;
  font-size: 16px;
  color: #4777e7;
}
.addStyleApprove {
  margin-left: 5px;
  font-size: 22px;
  line-height: 32px;
  color: #5584ff;
  cursor: pointer;
}
.noClick{
  cursor: not-allowed
}
</style>
